import { createFileRoute } from '@tanstack/react-router';
import { GroupingRuleSetTypes } from '../../../../../../../../views/Settings/GroupingRules/types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/vulnerabilities/settings/rule-set/create/{-$ruleIndex}/')({
  staticData: {
    groupingRuleType: GroupingRuleSetTypes.Ticket,
  },
});
